module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/190.71c6dedb.png";